import { Routes, Route } from 'react-router-dom';
import Home from './Components/Home';
import TermsofService from './Components/TermsofService';
import PrivacyPolicy from './Components/PrivacyPolicy';
import ContactUs from './Components/ContactUs';
import UsePageTracking from './Common/UsePageTracking';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useEffect, useState } from 'react';
import axios from 'axios';
import UserAccount from './Components/UserAccount';
import PricingPage from './Components/PricingPage';
import RefundPolicy from './Components/RefundPolicy';
import ScrollToTop from './Common/ScrollToTop';
import PaypalPaymentSuccess from './Components/PaypalPaymentSuccess'
import { sentryLog } from './Utils/SentryLog';
import './Styles/styles.scss';
import './Styles/maxWidth1024.scss';
import './Styles/mobileStyles.scss';
import './Styles/mobileStyles2.scss';
import './Styles/iPadMini.scss'; // ipad Mini
import './Styles/tabletStyles.scss';
import './Styles/tabletStyles2.scss';
import AffiliatePage from './Components/AffiliatePage';
import YtCommentFilterHome from './Components/YT Comment Filter/Home';
import SlidesExtensionPricingPage from './Components/SlidesExtensionPricingPage';
import SheetsExtensionPricingPage from './Components/SheetsExtensionPricingPage';
import SheetsExtensionTermsOfService from './Components/SheetsExtensionTermsOfService';
import SheetsExtensionPrivacyPolicy from './Components/SheetsExtensionPrivacyPolicy';
import SheetsExtensionContactUs from './Components/SheetsExtensionContactUs';
import SlidesExtensionContactUs from './Components/SlidesExtensionContactUs';
import SheetsExtensionUserAccount from './Components/SheetsExtensionUserAccount';
import SheetsExtensionFaq from './Components/SheetsExtensionFaq';
import TableOCRHome from './Components/Table OCR Extension/Home';
import SignupSuccess from './Components/SignupSuccess';
import SheetsExtensionFeedback from './Components/SheetsExtensionFeedback';
import Feedback from './Components/Feedback';
import HandwritingOcrHome from './Components/HandwritingOcrHome';
import BlogImportPdfTableToGoogleSheets from './Components/Blogs/BlogImportPdfTableToGoogleSheets';
import SheetsExtensionBlogs from './Components/SheetsExtensionBlogs';
import SheetsExtensionAffiliate from './Components/SheetsExtensionAffiliate';
import SheetsExtensionAffiliateOnboarding from './Components/SheetsExtensionAffiliateOnboarding';
import SheetsExtensionAffiliateKit from './Components/SheetsExtensionAffiliateKit';
import YCFTermsOfService from './Components/YCFTermsOfService';
import YCFPrivacyPolicy from './Components/YCFPrivacyPolicy';
import SlidesExtensionUserAccount from './Components/SlidesExtensionUserAccount';
import SlidesHome from './Components/SlidesHome';
import SlidesExtensionTermsOfService from './Components/SlidesExtensionTermsOfService';
import SlidesExtensionPrivacyPolicy from './Components/SlidesExtensionPrivacyPolicy';

const setExchangeRate = async () => {
  try {
      const res = await fetch("https://v6.exchangerate-api.com/v6/0ed217ecc1b28d82dee20108/latest/USD");
      const data = await res.json();
      const conversionRate = data?.conversion_rates?.INR;
      localStorage.setItem("conversionRate", conversionRate);
  } catch (err) {
      console.error("setExchangeRate Failed:", err);
      return null;
  }
};

const getUserCountry = async () => {
  try {
      const res = await fetch("https://ipapi.co/json/");
      const data = await res.json();
      return data.country; // e.g., "IN", "US", "PH"
  } catch (err) {
      console.error("Geolocation fetch failed:", err);
      return null;
  }
};

function App(){

  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const [isIndianUser, setIsIndianUser] = useState(null);

  const isShowConsole = process.env.NODE_ENV === 'development';

  UsePageTracking();

  const API_BASE_URL = process.env.NODE_ENV === 'development' 
    ? process.env.REACT_APP_LOCAL_API_URL 
    : process.env.REACT_APP_API_URL;

  const handleStorageChange = (e) => {
    if (e.key !== "userUpgradedViaPaypal") return;
    console.log('ssrk storage event detected: ', e.key, "::", e.newValue);
    if (e.key === "userUpgradedViaPaypal" && e.newValue === "true") {
      console.log("🔁 Premium status detected in another tab. Refreshing...");
      localStorage.removeItem("userUpgradedViaPaypal"); // ✅ clean up
      window.location.reload(); // 🔁 refresh to reflect premium
    }
  };

  useEffect(() => {

    const init = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/me`, { withCredentials: true });
        isShowConsole && console.log('api me res: ', res.data.user);
        setIsUserLoggedIn(res.data.user ? true : false);
      } catch (err) {
        const msg = err instanceof Error
          ? err.message
          : typeof err === 'string'
          ? err
          : JSON.stringify(err || 'Unknown error');
        isShowConsole && console.log('api me error: ', msg);
        sentryLog(`App.js - /api/me failed: ${msg}`);
      }
  
      const country = await getUserCountry();
      setIsIndianUser(country?.toUpperCase() === 'IN');

      //await setExchangeRate();
    };
  
    init();

    function setupLemonSqueezyHandler(){
      try{
        if (window.LemonSqueezy) {
          window.LemonSqueezy.Setup({
            eventHandler: (event) => {
              if (event.event === "Checkout.Success") {
                localStorage.setItem('shouldNotifyUserUpgrade', 'true');
                // Fetch updated user info or reload the app
                window.location.reload();
              }
            }
          });
        }else {
          // Try again in 200ms if not loaded yet
          setTimeout(setupLemonSqueezyHandler, 200);
        }
      }catch(lErr){
        console.log('error in lemonsqueezy event handler setup: ', lErr);
      }
    }

    setupLemonSqueezyHandler();

    window.addEventListener("storage", handleStorageChange);
      
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);
  
  return(
    <>
      <ScrollToTop/>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/handwriting-ocr" element={<HandwritingOcrHome />} />
        <Route path="/signup-success" element={<SignupSuccess />} />
        <Route path="/yt-comment-filter" element={<YtCommentFilterHome />} />
        <Route path="/pdf-to-google-sheets-converter" element={<TableOCRHome />} />
        <Route path="/pdf-to-google-slides-converter" element={<SlidesHome />} />
        <Route path="/terms-of-service" element={<TermsofService />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/user-account" element={<UserAccount isIndianUser={isIndianUser}/>} />
        <Route path="/pricing" element={<PricingPage isIndianUser={isIndianUser}/>} />
        <Route path="/sheets-extension-pricing" element={<SheetsExtensionPricingPage isIndianUser={isIndianUser}/>} />
        <Route path="/slides-extension-pricing" element={<SlidesExtensionPricingPage isIndianUser={isIndianUser}/>} />
        <Route path="/sheets-extension-terms-of-service" element={<SheetsExtensionTermsOfService isIndianUser={isIndianUser}/>} />
        <Route path="/sheets-extension-privacy-policy" element={<SheetsExtensionPrivacyPolicy isIndianUser={isIndianUser}/>} />
        <Route path="/slides-extension-terms-of-service" element={<SlidesExtensionTermsOfService isIndianUser={isIndianUser}/>} />
        <Route path="/slides-extension-privacy-policy" element={<SlidesExtensionPrivacyPolicy isIndianUser={isIndianUser}/>} />
        <Route path="/ycf-terms-of-service" element={<YCFTermsOfService isIndianUser={isIndianUser}/>} />
        <Route path="/ycf-privacy-policy" element={<YCFPrivacyPolicy isIndianUser={isIndianUser}/>} />
        <Route path="/sheets-extension-contact-us" element={<SheetsExtensionContactUs isIndianUser={isIndianUser}/>} />
        <Route path="/slides-extension-contact-us" element={<SlidesExtensionContactUs isIndianUser={isIndianUser}/>} />
        <Route path="/sheets-extension-user-account" element={<SheetsExtensionUserAccount />} />
        <Route path="/slides-extension-user-account" element={<SlidesExtensionUserAccount />} />
        <Route path="/sheets-extension-faq" element={<SheetsExtensionFaq />} />
        <Route path="/sheets-extension-blogs" element={<SheetsExtensionBlogs />} />
        <Route path="/sheets-extension-affiliate" element={<SheetsExtensionAffiliate />} />
         <Route path="/sheets-extension-affiliate-onboarding" element={<SheetsExtensionAffiliateOnboarding />} />
        <Route path="/sheets-extension-affiliate-kit" element={<SheetsExtensionAffiliateKit />} />
        <Route path="/sheets-extension-feedback" element={<SheetsExtensionFeedback />} />
        <Route path="/feedback" element={<Feedback />} />
        <Route path="/affiliate" element={<AffiliatePage isIndianUser={isIndianUser}/>} />
        <Route path="/payment-success" element={<PaypalPaymentSuccess />} />
        <Route path='/import-pdf-table-to-google-sheets' element={<BlogImportPdfTableToGoogleSheets />}/>
      </Routes>
      <ToastContainer position="bottom-right" autoClose={3000} />
    </>
  )
}

export default App;